<template>
  <div>
    <Header />
    <v-container class="mt-15 mb-16" :style="[{ minHeight: `${BodyHeight - 232}px` }]">
      <v-row>
        <v-col cols="12" md="8" align="start" v-if="applySuccess">
          <!-- #region 申請成功 -->
          <div class="my-6 text-h4 font-weight-black">
            {{ block1.title }}
          </div>
          <div align="center">
            <v-img :src="blockSuccess.img" max-width="155" contain></v-img>
            <div class="text-h6 font-weight-black green--text mt-6">
              {{ blockSuccess.text1 }}
            </div>
            <div class="text-h6 font-weight-black mb-2">
              {{ blockSuccess.text2 }}
            </div>
            <div style="max-width: 500px">
              {{ blockSuccess.text3 }}
              <a href="https://tawk.to/chat/62b3d0b47b967b1179960b5d/1g676eh8t" target="_blank">{{ blockSuccess.text4 }}</a
              >。
            </div>
            <v-btn class="mt-6 mb-10" color="primary" x-large min-width="300" @click="ApplyAgain()">{{ blockSuccess.btn.name }}</v-btn>
          </div>
          <!-- #endregion -->

          <!-- #region 繼續前往 -->
          <div class="text-h6 font-weight-black mb-4">
            {{ blockGoTo.title }}
          </div>
          <v-row>
            <v-col cols="12" sm="4" v-for="x in blockGoTo.data" :key="x.id">
              <div>
                <a :href="x.url" target="_blank">
                  <v-img :src="x.img" style="border-radius: 12px"></v-img>
                </a>
                <div class="mt-2 mb-1 font-weight-black">{{ x.title }}</div>
                <div class="text--secondary">{{ x.sub }}</div>
              </div>
            </v-col>
          </v-row>
          <div style="height: 240px"></div>
          <!-- #endregion-->
        </v-col>

        <!-- #region 填寫表單 -->
        <v-col cols="12" md="8" align="start" v-else>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <!-- #region Block 1 小芋頭廣告申請-->
            <div class="my-6 text-h4 font-weight-black">
              {{ service ? block1.title2 : block1.title }}
            </div>

            <v-img class="mb-4" :src="$vuetify.breakpoint.width > 500 ? block1.step.lg : block1.step.sm"></v-img>

            <div>
              <ul v-for="(x, i) in block1.contant" :key="i">
                <li :class="i === block1.contant.length - 1 ? 'red--text accent-2' : ''">
                  {{ x }}
                </li>
              </ul>
            </div>

            <!-- #endregion -->

            <!-- #region Block 2 廣告申請人-->
            <div class="my-13">
              <div class="d-flex align-center mb-6 text-h6 font-weight-black"><v-icon class="mr-1">mdi-numeric-1-circle</v-icon>{{ block2.title }}</div>
              <v-text-field
                class="input-width pb-2"
                v-model="block2.field1.value"
                :placeholder="block2.field1.placeholder"
                :rules="block2.field1.rules"
                :error-messages="block2.field1.errorMsg"
                :maxlength="block2.field1.maxlength"
                validate-on-blur
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block2.field1.label }}
                  <span class="red--text accent-2"> *</span>
                </template></v-text-field
              >
              <v-text-field
                class="input-width pb-2"
                v-model="block2.field2.value"
                :placeholder="block2.field2.placeholder"
                :rules="block2.field2.rules"
                :error-messages="block2.field2.errorMsg"
                :maxlength="block2.field2.maxlength"
                validate-on-blur
                append-icon="mdi-email"
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block2.field2.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
              </v-text-field>
              <v-text-field
                class="input-width pb-2"
                v-model="block2.field3.value"
                :placeholder="block2.field3.placeholder"
                :rules="block2.field3.rules"
                :error-messages="block2.field3.errorMsg"
                :maxlength="block2.field3.maxlength"
                validate-on-blur
                append-icon="mdi-phone"
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block2.field3.label }}
                  <span class="red--text accent-2"> *</span>
                </template></v-text-field
              >
            </div>

            <!-- #endregion -->
            <v-divider></v-divider>
            <!-- #region Block 3 申請單位-->
            <div class="mt-6 mb-13">
              <div class="d-flex align-center mb-6 text-h6 font-weight-black"><v-icon class="mr-1">mdi-numeric-2-circle</v-icon>{{ block3.title }}</div>
              <div class="font-weight-black mb-2">
                {{ block3.sub }}
              </div>
              <div class="">
                {{ block3.sub2 }}
              </div>
              <div class="mb-6 red--text">{{ block3.sub3 }}請 <a href="https://kingfong9595.blog/contact-taro/" target="_blank">聯絡我們</a>。</div>
              <!-- <v-autocomplete
                class="input-width pb-2"
                v-model="block3.field1.value"
                :items="companyDatas"
                item-text="公司名稱"
                item-value="公司統編"
                :label="block3.field1.label"
                :placeholder="block3.field1.placeholder"
                :rules="block3.field1.rules"
                :error-messages="block3.field1.errorMsg"
                :loading="block3.field1.loading"
                :search-input.sync="block3.field1.search"
                @keyup.enter="GetCompanyData_API(block3.field1.search)"
                hide-no-data
                hide-selected
                return-object
                validate-on-blur
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block3.field1.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
              </v-autocomplete> -->
              <v-menu v-model="companyMenu" offset-y nudge-top="32" max-height="250" allow-overflow>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="input-width pb-2"
                    v-model="block3.field1.search"
                    :label="block3.field1.label"
                    :placeholder="block3.field1.placeholder"
                    :rules="block3.field1.rules"
                    :error-messages="block3.field1.errorMsg"
                    :loading="block3.field1.loading"
                    :maxlength="block3.field1.maxlength"
                    validate-on-blur
                    outlined
                    dense
                    v-on="on"
                  >
                    <template v-slot:label>
                      {{ block3.field1.label }}
                      <span class="red--text accent-2"> *</span>
                    </template>
                  </v-text-field>
                </template>
                <v-card v-if="noCompanyData">
                  <!-- <div class="pa-3 text-body-2 text--secondary">
                    {{ keyin }}
                  </div> -->
                </v-card>
                <div v-else>
                  <v-card v-if="block3.field1.loading" class="pa-3 text-body-2">
                    {{ searching }}
                  </v-card>
                  <v-list v-else class="pa-0">
                    <v-list-item dense v-for="(x, index) in companyDatas" :key="index" link @click="SeletctCompany(x)" @keydown="SeletctCompany(x)">
                      <v-list-item-title class="text-body-2" style="cursor: pointer">{{ x.公司名稱 }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </div>
              </v-menu>

              <v-text-field
                class="input-width pb-2"
                v-model="block3.field2.value"
                :label="block3.field2.label"
                :placeholder="block3.field2.placeholder"
                :rules="block3.field2.rules"
                :error-messages="block3.field2.errorMsg"
                :maxlength="block3.field2.maxlength"
                append-icon="mdi-home-city"
                @click="AddressDialogOpen()"
                validate-on-blur
                readonly
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block3.field2.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
              </v-text-field>
              <v-select
                class="input-width pb-2"
                v-model="block3.field3.value"
                :label="block3.field3.label"
                :placeholder="block3.field3.placeholder"
                :items="block3.field3.items"
                :rules="block3.field3.rules"
                :error-messages="block3.field3.errorMsg"
                @click="IndustryDialogOpen()"
                append-icon="mdi-menu-down"
                validate-on-blur
                outlined
                dense
                multiple
              >
                <template v-slot:label>
                  {{ block3.field3.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="text-caption"> ( +{{ block3.field3.value.length - 1 }} ) </span>
                </template>
              </v-select>
              <v-text-field
                class="input-width pb-2"
                v-model="block3.field4.value"
                :label="block3.field4.label"
                :placeholder="block3.field4.placeholder"
                :rules="block3.field4.rules"
                :error-messages="block3.field4.errorMsg"
                :maxlength="block3.field4.maxlength"
                validate-on-blur
                outlined
                dense
              ></v-text-field>
              <v-text-field
                class="input-width pb-2"
                v-model="block3.field6.value"
                :label="block3.field6.label"
                :placeholder="block3.field6.placeholder"
                :rules="block3.field6.rules"
                :error-messages="block3.field6.errorMsg"
                :maxlength="block3.field6.maxlength"
                validate-on-blur
                outlined
                dense
              ></v-text-field>
              <!-- <v-checkbox
                class="mt-0"
                v-model="block3.field5.value"
                :label="block3.field5.label"
              ></v-checkbox> -->
            </div>
            <!-- #endregion -->
            <v-divider></v-divider>
            <!-- #region Block 4 廣告資訊-->
            <div class="mt-6 mb-13">
              <div class="d-flex align-center mb-6 text-h6 font-weight-black"><v-icon class="mr-1">mdi-numeric-3-circle</v-icon>{{ block4.title }}</div>
              <div class="font-weight-black mb-2">
                {{ block4.sub }}
              </div>
              <div class="mb-6">
                <ul v-for="(x, i) in block4.contant" :key="i">
                  <li>{{ x }}</li>
                </ul>
              </div>
              <v-select
                class="input-width pb-2"
                v-model="block4.field1.selected"
                :label="block4.field1.label"
                :placeholder="block4.field1.placeholder"
                :items="block4.field1.items"
                :rules="block4.field1.rules"
                :error-messages="block4.field1.errorMsg"
                append-icon="mdi-menu-down"
                item-text="name"
                item-value="id"
                validate-on-blur
                outlined
                dense
                multiple
                chips
                small-chips
                readonly
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="text-caption">( +{{ block4.field1.value.length - 1 }} )</span>
                </template>
              </v-select>

              <!-- <v-menu
                ref="b4f2menu"
                v-model="block4.field2.menu"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="auto"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="input-width pb-2"
                    v-model="block4.field2.value"
                    :label="block4.field2.label"
                    :placeholder="block4.field2.placeholder"
                    :rules="block4.field2.rules"
                    :error-messages="block4.field2.errorMsg"
                    append-icon="mdi-calendar-month"
                    validate-on-blur
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="block4.field2.date"
                  :active-picker.sync="block4.field2.activePicker"
                  min="1950-01-01"
                  locale="zh-TW"
                  @change="b4f2menuSave"
                ></v-date-picker>
              </v-menu>

              <v-menu
                ref="b4f3menu"
                v-model="block4.field3.menu"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="auto"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="input-width pb-2"
                    v-model="block4.field3.value"
                    :label="block4.field3.label"
                    :placeholder="block4.field3.placeholder"
                    :rules="block4.field3.rules"
                    :error-messages="block4.field3.errorMsg"
                    append-icon="mdi-calendar-month"
                    validate-on-blur
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="block4.field3.date"
                  :active-picker.sync="block4.field3.activePicker"
                  locale="zh-TW"
                  min="1950-01-01"
                  @change="b4f3menuSave"
                ></v-date-picker>
              </v-menu> -->

              <v-select
                class="input-width pb-2"
                v-model="block4.field4.value"
                :label="block4.field4.label"
                :placeholder="block4.field4.placeholder"
                :rules="block4.field4.rules"
                :error-messages="block4.field4.errorMsg"
                :items="block4.field4.items"
                append-icon="mdi-menu-down"
                @click="CategoryDialogOpen()"
                validate-on-blur
                outlined
                dense
                multiple
                chips
                small-chips
              >
                <template v-slot:label>
                  {{ block4.field4.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="text-caption">( +{{ block4.field4.value.length - 1 }} )</span>
                </template>
              </v-select>

              <v-textarea
                class="input-width pb-6"
                v-model="block4.field6.value"
                :label="block4.field6.label"
                :placeholder="block4.field6.placeholder"
                :rules="block4.field6.rules"
                :error-messages="block4.field6.errorMsg"
                :hint="block4.field6.hint"
                :maxlength="block4.field6.maxlength"
                append-icon="mdi-link"
                validate-on-blur
                persistent-hint
                outlined
                rows="2"
              >
                <template v-slot:label>
                  {{ block4.field6.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
              </v-textarea>
              <!-- <v-text-field
                class="input-width pb-6"
                v-model="block4.field6.value"
                :label="block4.field6.label"
                :placeholder="block4.field6.placeholder"
                :rules="block4.field6.rules"
                :error-messages="block4.field6.errorMsg"
                :hint="block4.field6.hint"
                :maxlength="block4.field6.maxlength"
                append-icon="mdi-link"
                validate-on-blur
                persistent-hint
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block4.field6.label }}
                  <span class="red--text accent-2"> *</span>
                </template>
              </v-text-field> -->

              <!-- 選擇廣告地區 -->
              <div class="font-weight-black mb-2">
                {{ block4.areaSub }}
              </div>
              <div class="mb-6">
                {{ block4.areaSub2 }}
                <span>
                  <a href="https://taro.kf-9595.com/ads" target="_blank">{{ block4.areaSub2a }}</a></span
                >
                {{ block4.areaSub2b }}
              </div>

              <v-select
                class="input-width pb-2"
                v-model="block4.field5.value"
                :label="block4.field5.label"
                :placeholder="block4.field5.placeholder"
                :rules="block4.field5.rules"
                :error-messages="block4.field5.errorMsg"
                :items="block4.field5.items"
                append-icon="mdi-menu-down"
                @click="AreaDialogOpen()"
                validate-on-blur
                outlined
                dense
                multiple
                chips
                small-chips
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2" small>
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 2" class="text-caption">( +{{ block4.field5.value.length - 2 }} )</span>
                </template>
              </v-select>

              <!-- <v-text-field
                class="input-width pb-6"
                v-model="block4.field7.value"
                :label="block4.field7.label"
                :placeholder="block4.field7.placeholder"
                :rules="block4.field7.rules"
                :error-messages="block4.field7.errorMsg"
                :hint="block4.field7.hint"
                validate-on-blur
                persistent-hint
                outlined
                dense
              >
                <template v-slot:label>
                  {{ block4.field7.label }}
                  <span class="red--text accent-2"> * </span>
                  ({{ block4.field7.label2 }})
                </template>
              </v-text-field> -->
            </div>
            <!-- #endregion -->
            <v-divider></v-divider>
            <!-- #region Block 5 廣告製作與上傳-->
            <div class="mt-6 mb-13" v-if="!service">
              <div class="d-flex align-center text-h6 font-weight-black">
                <v-icon class="mr-1">mdi-numeric-4-circle</v-icon>
                {{ block5.title }}
              </div>

              <!-- #region 廣告圖說明 -->
              <div class="my-6 mb-13">
                <div class="font-weight-black mb-2">
                  {{ block5.sub }}
                </div>
                <div class="mb-6">
                  {{ block5.child1.sub }}
                  <ul v-for="(x, i) in block5.child1.contant" :key="i">
                    <li>{{ x }}</li>
                  </ul>
                </div>
                <a :href="block5.child1.img" target="_blank" rel="noreferrer noopenner">
                  <v-img :src="block5.child1.img" alt="說明圖" />
                </a>
              </div>
              <!-- #endregion -->
              <!-- #region 上傳廣告圖 -->
              <div class="mb-13">
                <div class="mb-2 font-weight-black">
                  {{ block5.child2.title }}
                  <span class="red--text accent-2"> *</span>
                </div>
                <v-file-input
                  v-model="block5.child2.lg.value"
                  :label="block5.child2.lg.label"
                  :hint="block5.child2.lg.hint"
                  :rules="block5.child2.lg.rules"
                  :error-messages="block5.child2.lg.errorMsg"
                  @change="ImgUploadEvent($event, 'lg')"
                  accept="image/*"
                  persistent-hint
                  append-icon="mdi-cloud-upload"
                  validate-on-blur
                  prepend-icon=""
                  class="input-width mb-6"
                  filled
                ></v-file-input>
                <v-file-input
                  v-model="block5.child2.md.value"
                  :label="block5.child2.md.label"
                  :hint="block5.child2.md.hint"
                  :rules="block5.child2.md.rules"
                  :error-messages="block5.child2.md.errorMsg"
                  @change="ImgUploadEvent($event, 'md')"
                  accept="image/*"
                  persistent-hint
                  append-icon="mdi-cloud-upload"
                  validate-on-blur
                  prepend-icon=""
                  class="input-width mb-6"
                  filled
                ></v-file-input>
                <v-file-input
                  v-model="block5.child2.sm.value"
                  :label="block5.child2.sm.label"
                  :hint="block5.child2.sm.hint"
                  :rules="block5.child2.sm.rules"
                  :error-messages="block5.child2.sm.errorMsg"
                  @change="ImgUploadEvent($event, 'sm')"
                  accept="image/*"
                  persistent-hint
                  append-icon="mdi-cloud-upload"
                  validate-on-blur
                  prepend-icon=""
                  class="input-width"
                  filled
                ></v-file-input>
              </div>
              <!-- #endregion -->
              <!-- #region 意願調查 -->
              <div class="mb-13">
                <!-- <div class="mb-2 font-weight-black">
                  {{ block5.child3.title }}
                </div> -->
                <!-- <template v-for="x in block5.child3.items">
                  <v-checkbox
                    :key="x.id"
                    class="mt-4"
                    v-model="block5.child3.selected"
                    :label="x.name"
                    :value="x.id"
                    hide-details
                  ></v-checkbox>
                </template> -->
                <div class="my-10"></div>

                <v-checkbox v-model="block5.child3.field4.value" :label="block5.child3.field4.label" :error-messages="block5.child3.field4.errorMsg" hide-details></v-checkbox>

                <v-textarea class="mt-1 text-body-2" :value="block5.child3.field4.contant" @scroll="HandleScroll($event)" hide-details readonly outlined></v-textarea>
              </div>
              <!-- #endregion -->
            </div>
            <!-- #endregion -->

            <!-- #region Block 5 ver.2 廣告製作與上傳 (免費服務) -->
            <div class="mt-6 mb-13" v-else>
              <div class="d-flex align-center text-h6 font-weight-black"><v-icon class="mr-1">mdi-numeric-4-circle</v-icon>{{ block5ver2.title }}</div>

              <!-- #region 廣告圖說明 -->
              <div class="my-6 mb-13">
                <div class="font-weight-black mb-2">
                  {{ block5.sub }}
                </div>
                <div class="mb-6">
                  <div>
                    {{ block5ver2.child1.sub }}
                  </div>
                  <div class="red--text accent-2">
                    {{ block5ver2.child1.sub2 }}
                  </div>
                </div>

                <a :href="block5ver2.child1.img" target="_blank" rel="noreferrer noopenner">
                  <v-img :src="block5ver2.child1.img" alt="說明圖" />
                </a>
              </div>
              <!-- #endregion -->
              <!-- #region 上傳廣告圖 -->
              <div class="mb-13">
                <div class="mb-2 font-weight-black">
                  {{ block5ver2.child2.title }}
                  <span class="red--text accent-2"> *</span>
                </div>
                <v-file-input
                  v-model="block5ver2.child2.field1.value"
                  :label="block5ver2.child2.field1.label"
                  :hint="block5ver2.child2.field1.hint"
                  :rules="block5ver2.child2.field1.rules"
                  :error-messages="block5ver2.child2.field1.errorMsg"
                  @change="ImgUploadEvent($event, 'c1')"
                  validate-on-blur
                  persistent-hint
                  accept="image/*"
                  append-icon="mdi-cloud-upload"
                  prepend-icon=""
                  class="input-width"
                  filled
                ></v-file-input>
                <div class="mb-6">
                  <div v-if="block5ver2.child2.field1.src" class="image-container" @click="block5ver2.child2.field1.value = null">
                    <v-btn icon small class="delete-button">
                      <v-icon size="20"> mdi-close</v-icon>
                    </v-btn>
                    <img :src="block5ver2.child2.field1.src" alt="" class="pre-img" />
                  </div>
                </div>

                <v-file-input
                  v-model="block5ver2.child2.field2.value"
                  :label="block5ver2.child2.field2.label"
                  :hint="block5ver2.child2.field2.hint"
                  :rules="block5ver2.child2.field2.rules"
                  :error-messages="block5ver2.child2.field2.errorMsg"
                  @change="ImgUploadEvent($event, 'c2')"
                  validate-on-blur
                  accept="image/*"
                  persistent-hint
                  append-icon="mdi-cloud-upload"
                  prepend-icon=""
                  class="input-width"
                  filled
                ></v-file-input>
                <div class="mb-6">
                  <div v-if="block5ver2.child2.field2.src" class="image-container mb-4" @click="block5ver2.child2.field2.value = null">
                    <v-btn icon small class="delete-button">
                      <v-icon size="20"> mdi-close</v-icon>
                    </v-btn>
                    <img :src="block5ver2.child2.field2.src" alt="" class="pre-img" />
                  </div>
                </div>

                <v-text-field
                  v-model="block5ver2.child2.field3.value"
                  :rules="block5ver2.child2.field3.rules"
                  :label="block5ver2.child2.field3.label"
                  :hint="block5ver2.child2.field3.hint"
                  :counter="block5ver2.child2.field3.maxlength"
                  :maxlength="block5ver2.child2.field3.maxlength"
                  :error-messages="block5ver2.child2.field3.errorMsg"
                  validate-on-blur
                  class="input-width mb-6"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="block5ver2.child2.field4.value"
                  :rules="block5ver2.child2.field4.rules"
                  :label="block5ver2.child2.field4.label"
                  :hint="block5ver2.child2.field4.hint"
                  :counter="block5ver2.child2.field4.maxlength"
                  :maxlength="block5ver2.child2.field4.maxlength"
                  :error-messages="block5ver2.child2.field4.errorMsg"
                  validate-on-blur
                  class="input-width mb-6"
                  outlined
                  dense
                ></v-text-field>
              </div>
              <!-- #endregion -->
              <!-- #region 意願調查 -->
              <div class="mb-13">
                <!-- <div class="mb-2 font-weight-black">
                  {{ block5ver2.child3.title }}
                </div> -->
                <!-- <template v-for="x in block5ver2.child3.items">
                  <v-checkbox
                    :key="x.id"
                    class="mt-4"
                    v-model="block5ver2.child3.selected"
                    :label="x.name"
                    :value="x.id"
                    hide-details
                  ></v-checkbox>
                </template> -->
                <div class="my-10"></div>

                <v-checkbox v-model="block5ver2.child3.field4.value" :label="block5ver2.child3.field4.label" :error-messages="block5ver2.child3.field4.errorMsg" hide-details></v-checkbox>

                <v-textarea class="mt-1 text-body-2" :value="block5ver2.child3.field4.contant" @scroll="HandleScroll($event)" hide-details readonly outlined></v-textarea>
              </div>
              <!-- #endregion -->
            </div>
            <!-- #endregion -->

            <!-- #region 送出申請按鈕-->
            <div align="center">
              <v-btn :loading="applyBtn.loading" :disabled="!block5.child3.field4.value || !block5ver2.child3.field4.value" @click="Apply()" color="primary" x-large width="300">{{
                applyBtn.name
              }}</v-btn>
            </div>
            <!-- #endregion -->

            <!-- #region 必填未填alert-->
            <v-card height="40" elevation="0" class="mt-6 mb-10" style="background: none">
              <v-expand-transition>
                <div v-show="validAlert">
                  <v-alert type="error" dense>{{ alertText }} </v-alert>
                </div>
              </v-expand-transition>
            </v-card>

            <!-- #endregion -->
          </v-form>
        </v-col>
        <!-- #endregion -->

        <!-- #region 右邊/下面 連結List -->
        <v-col cols="12" md="4" class="pt-13 pt-md-0">
          <v-img :src="bannerImg" contain class="mb-6"></v-img>
          <v-list>
            <v-list-item v-for="x in links" :key="x.title" @click="LinkingTo(x.url)">
              <v-list-item-icon>
                <v-icon v-text="x.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content align="left">
                <v-list-item-title v-text="x.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <!-- #endregion -->
      </v-row>
    </v-container>
    <!-- #region 地址彈窗-->
    <v-dialog v-model="addressDialog.show" width="500" @click:outside="addressDialog.show = false">
      <v-card>
        <v-card-title class="mb-4">
          <div class="font-weight-black">{{ addressDialog.title }}</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="addressDialog.show = false"> <v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            class="pb-2"
            v-model="addressDialog.field1.value"
            :label="addressDialog.field1.label"
            :placeholder="addressDialog.field1.placeholder"
            :items="addressDialog.field1.items"
            :rules="addressDialog.field1.rules"
            :error-messages="addressDialog.field1.errorMsg"
            menu-props="auto"
            readonly
            disabled
            outlined
            dense
          >
          </v-select>
          <v-select
            class="pb-2"
            v-model="addressDialog.field2.value"
            :label="addressDialog.field2.label"
            :placeholder="addressDialog.field2.placeholder"
            :items="addressDialog.field2.items"
            :rules="addressDialog.field2.rules"
            :error-messages="addressDialog.field2.errorMsg"
            outlined
            dense
          >
          </v-select>
          <v-row>
            <v-col>
              <v-select
                class="pb-2"
                v-model="addressDialog.field3.value"
                :label="addressDialog.field3.label"
                :placeholder="addressDialog.field3.placeholder"
                :items="addressDialog.field3.items"
                :rules="addressDialog.field3.rules"
                :error-messages="addressDialog.field3.errorMsg"
                outlined
                dense
              >
              </v-select
            ></v-col>
            <v-col>
              <v-text-field
                class="pb-2"
                v-model="addressDialog.field4.value"
                :label="addressDialog.field4.label"
                :placeholder="addressDialog.field4.placeholder"
                :rules="addressDialog.field4.rules"
                :error-messages="addressDialog.field4.errorMsg"
                outlined
                dense
              >
              </v-text-field
            ></v-col>
          </v-row>
          <v-textarea
            id="address"
            class="pb-2"
            v-model="addressDialog.field5.value"
            :label="addressDialog.field5.label"
            :placeholder="addressDialog.field5.placeholder"
            :rules="addressDialog.field5.rules"
            :error-messages="addressDialog.field5.errorMsg"
            @focus="ScrollTo('address')"
            hide-details
            outlined
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer>
          <v-btn text @click="addressDialog.show = false">{{ addressDialog.close }}</v-btn>
          <v-btn color="primary" @click="AddressDialogConfirm()">{{ addressDialog.confirm }}</v-btn></v-card-actions
        >
      </v-card>
    </v-dialog>

    <!-- #endregion -->
    <!-- #region 公司行業別彈窗 -->
    <Industry
      :open="industryDialog.show"
      :clear="industryDialog.clear"
      :originList="industryDialog.selectedList"
      v-on:close="IndustryDialogClose"
      v-on:list="IndustryResultList"
      v-on:formatList="IndustryResultFormatList"
    />
    <!-- #endregion -->
    <!-- #region 廣告類型彈窗 -->
    <Category :open="categoryDialog.show" v-on:close="CategoryDialogClose" v-on:list="CategoryResultList" v-on:formatList="CategoryResultFormatList" />
    <!-- #endregion -->
    <!-- #region 廣告地區彈窗 -->
    <Area
      :open="areaDialog.show"
      :clear="areaDialog.clear"
      :originList="areaDialog.selectedList"
      :searchMod="false"
      v-on:close="AreaDialogClose"
      v-on:list="AreaResultList"
      v-on:formatList="AreaResultFormatList"
    />
    <!-- #endregion -->
    <Footer />
  </div>
</template>

<script>
import {
  Advertise_Post,
  Advertise_Get_TaroSerivce,
  Advertise_Get_Questionnaire,
  Advertise_SemdAdminMail,
  //   GetCompanyData_Post,
  IndustryCategory_Get,
  Advertise_Get_Area,
  Advertise_Get_Dist,
  GetIndustryVAT,
  GetCompanyData,
} from '@/apis/api.js';

import Header from '../../components/Common/Header.vue';
import Footer from '../../components/Common/Footer.vue';
import Industry from '../../components/Ad/Industry.vue';
import Category from '../../components/Ad/Category.vue';
import Area from '../../components/Ad/Area.vue';

import industryJson from '@/assets/Industry.json';
import Cities from '@/assets/taiwan_districts.json';
const towns = Cities.map((x) => x.name);
const dic = {};
for (let i = 0; i < towns.length; i++) {
  dic[towns[i]] = Cities[i].areas.map((x) => x.name);
}

export default {
  components: {
    Header,
    Footer,
    Industry,
    Category,
    Area,
  },
  data() {
    return {
      bannerImg: require('@/assets/image/ads/AdsBanner.jpg'),
      applySuccess: false,
      service: true,
      formValid: true,
      validAlert: false,
      alertText: '尚有必填欄位未完成。',
      keyin: '請輸入公司名稱或自行輸入',
      searching: '搜尋中...',
      isSearching: false,
      noCompanyData: true,
      companyMenu: false,
      links: [
        {
          icon: 'mdi-script-text-outline',
          title: '小芋頭廣告首頁',
          url: process.env.VUE_APP_MAIN_BASE_URL + '/ads',
        },
        {
          icon: 'mdi-file-document-edit',
          title: '申請廣告',
          url: `${this.$route.path}`,
        },
        {
          icon: 'mdi-forum',
          title: '聯絡我們',
          url: 'https://tawk.to/chat/62b3d0b47b967b1179960b5d/1g676eh8t',
        },
        {
          icon: 'mdi-account-group',
          title: '小芋頭社群',
          url: 'https://tarosms.kf-9595.com/',
        },
      ],
      block1: {
        title: '小芋頭免費廣告申請',
        title2: '小芋頭免費廣告申請',
        sub: '👋 申請說明',
        contant: ['如有多筆廣告，請分開申請。', '有【*】的欄位為必填項目。'],
        step: {
          sm: require('@/assets/image/ads/stepSM.svg'),
          lg: require('@/assets/image/ads/stepLG.svg'),
        },
      },
      block2: {
        title: '廣告申請人',

        field1: {
          label: '您的姓名',
          placeholder: '',
          value: '',
          rules: [(v) => !!v || '此欄位必填'],
          errorMsg: '',
          maxlength: 50,
        },
        field2: {
          label: '電子郵件',
          placeholder: '',
          value: '',
          rules: [(v) => !!v || '此欄位必填', (v) => /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(v) || '請輸入正確的e-mail格式'],
          errorMsg: '',
          maxlength: 300,
        },
        field3: {
          label: '行動電話',
          placeholder: '',
          value: '',
          rules: [(v) => /^[0-9]+$/.test(v) || '請輸入數字'],
          errorMsg: '',
          maxlength: 50,
        },
      },
      block3: {
        title: '申請單位',
        sub: '👋 你也可以針對不同分店，上架不同的廣告',
        sub2: '請在以下申請單中填入「分店資訊」，並依照分店數量拆分為「多筆廣告申請單」與上傳不同廣告宣傳圖。',
        sub3: '※如果您需要一位顧問師協助，',
        field1: {
          label: '公司單位名稱',
          placeholder: '',
          value: '',
          rules: [(v) => !!v || '此欄位必填'],
          errorMsg: '',
          loading: false,
          search: '',
          searchResult: false,
          maxlength: 100,
        },
        field2: {
          label: '單位地址',
          placeholder: '',
          value: '',
          rules: [(v) => !!v || '此欄位必填'],
          errorMsg: '',
          maxlength: 100,
        },
        field3: {
          label: '單位行業別',
          placeholder: '',
          items: [],
          value: [],
          rules: [(v) => v.length > 0 || '此欄位必填'],
          errorMsg: '',
        },
        field4: {
          label: '介紹人姓名/電話',
          placeholder: '',
          value: '',
          rules: [],
          errorMsg: '',
          maxlength: 25,
        },
        field5: {
          label: '金豐合約有效客戶',
          placeholder: '',
          value: false,
          rules: [],
          errorMsg: '',
        },
        field6: {
          label: '顧問師姓名/電話',
          placeholder: '',
          value: '',
          rules: [],
          errorMsg: '',
          maxlength: 25,
        },
      },
      block4: {
        title: '廣告資訊',
        sub: '👋  資訊說明',
        areaSub: '👋  選擇廣告進階搜尋的地區',
        areaSub2: '若您的地區選擇為「屏東縣」，顧客在',
        areaSub2a: '廣告總覽',
        areaSub2b: '中，使用「進階篩選地區」為屏東縣時，將會精準出現您的廣告。',
        contant: ['廣告申請後約 7 個工作天完成。', '如果您沒有企業網站可以先申請免費會員網站作為連結。'],
        field1: {
          label: '選擇刊登服務',
          placeholder: '可複選',
          selected: [],
          rules: [],
          items: [],
          errorMsg: '',
        },
        field2: {
          label: '廣告上架日期 (選填)',
          placeholder: '請選擇',
          value: '',
          rules: [],
          errorMsg: '',
          activePicker: null,
          menu: false,
          date: null,
        },
        field3: {
          label: '廣告下架日期 (選填)',
          placeholder: '請選擇',
          value: '',
          rules: [],
          errorMsg: '',
          activePicker: null,
          menu: false,
          date: null,
        },
        field4: {
          label: '選擇廣告類型',
          placeholder: '',
          value: '',
          rules: [(v) => !!v || '此欄位必填'],
          errorMsg: '',
          items: [],
        },
        field5: {
          distDatas: [],
          label: '選擇廣告地區 (選填)',
          placeholder: '',
          value: '',
          rules: [],
          errorMsg: '',
          items: [],
        },
        field6: {
          label: '廣告連結網址',
          placeholder: 'https://',
          value: '',
          rules: [
            (v) => !!v || '此欄位必填',
            (v) => /^[^\u4e00-\u9fff]+$/.test(v) || '請輸入正確網址格式，網址中不得包含中文',
            (v) => /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/.test(v) || '請輸入正確網址格式',
          ],
          errorMsg: '',
          hint: '點擊您的廣告後將前往的連結網址',
          maxlength: 300,
        },
        field7: {
          label: '您預計的廣告預算',
          label2: '目前免費請填 0',
          placeholder: '',
          value: 0,
          rules: [(v) => /^[0-9]+$/.test(v) || '請輸入數字'],
          errorMsg: '',
          hint: '請填寫你預計花費的廣告金額',
        },
      },
      block5: {
        title: '廣告製作與上傳',
        sub: '👋  廣告圖說明',
        child1: {
          title: '廣告圖說明',
          sub: '【製作廣告】為確保廣告在所有裝置上呈現以下每一個最佳效果，請提供3種尺寸',
          contant: [
            ' 大尺寸 — 寬 1280ｘ高 90 像素（px），適用於電腦觀看。',
            ' 中尺寸 — 寬 1440ｘ高180 像素（px），適用於平板 iPad 觀看。',
            '小尺寸 — 寬 686ｘ高 146 像素（px），適用於手機觀看。',
            '請提供jpg、png、gif ..等圖片檔案格式 。',
            '右上角屏蔽區域請避開文案 (點擊下方圖片查看)',
          ],
          img: require('@/assets/image/ads/自行製作廣告-廣告說明.jpg'),
        },
        child2: {
          title: '上傳廣告圖',
          lg: {
            label: '請選擇大尺寸廣告圖檔',
            value: null,
            errorMsg: '',
            rules: [(v) => !!v || '此欄位必填'],
            hint: '請上傳用大小在 5 MB 以內的 PNG、GIF (不接受動畫)或 JPG 檔案',
          },
          md: {
            label: '請選擇中尺寸廣告圖檔',
            value: null,
            errorMsg: '',
            rules: [(v) => !!v || '此欄位必填'],
            hint: '請上傳用大小在 5 MB 以內的 PNG、GIF (不接受動畫)或 JPG 檔案',
          },
          sm: {
            label: '請選擇小尺寸廣告圖檔',
            value: null,
            errorMsg: '',
            rules: [(v) => !!v || '此欄位必填'],
            hint: '請上傳用大小在 5 MB 以內的 PNG、GIF (不接受動畫)或 JPG 檔案',
          },
        },
        child3: {
          title: '意願調查',
          selected: [],
          items: [],

          field4: {
            label: '小芋頭廣告服務【免責聲明】',
            contant: `當您使用小芋頭社群廣告服務後，您已詳細閱讀及明確瞭解本「免責聲明」並同意，屬下列情況發生時本網站毋須負擔任何責任：
一、您提供之廣告、廣告文案、廣告素材如有侵害他人著作權之風險會由您個人承擔。用戶同意使用「小芋頭社群廣告服務」系基於用戶的個人意願，並同意自負任何風險。

二、「小芋頭社群廣告服務」，不負任何明示或默示之擔保責任。「小芋頭社群廣告服務」不保證各項服務之穩定、安全、無誤、及不中斷；用戶明示承擔使用本服務之所有風險及可能發生之任何損害。

三、用戶在「小芋頭社群廣告申請」填寫之物件資訊、個人資料、上傳圖片等行為，純屬用戶個人行為，「小芋頭社群」對其內容之真實性或完整性不負有任何責任。

四、任何由於電腦病毒侵入或發作、因政府管制而造成的暫時性關閉等影響網路正常經營之不可抗力而造成的資料損毀、丟失、被盜用或被竄改等與「小芋頭社群」無關。

五、對於用戶透過「小芋頭社群」刊登或發布虛假、違法資訊、侵害他人權益及詐騙、敲詐行為者，純屬用戶個人行為「小芋頭社群」對因此而產生的一次糾紛不負任何責任！特此聲明。`,
            value: true,
            rules: [],
            errorMsg: '',
          },
        },
      },
      block5ver2: {
        title: '廣告製作與上傳',
        sub: '👋  廣告圖說明',
        child1: {
          title: '廣告圖說明',
          sub: '小芋頭提供免費製作廣告服務，請依下方圖片提示（點擊圖片可放大），自由提供相應的文案與素材以利廣告製作。',
          sub2: '※小芋頭僅提供廣告圖像代為製作，無提供文案企劃、免費廣告素材..等服務。',

          img: require('@/assets/image/ads/需協助製作廣告-廣告說明(製作規格).jpg'),
        },
        child2: {
          title: '上傳廣告圖',
          field1: {
            label: '請選擇圖片 1',
            value: null,
            errorMsg: '',
            rules: [(v) => !!v || '此欄位必填'],
            hint: '請上傳用大小在 5 MB 以內的 PNG、GIF (不接受動畫)或 JPG 檔案',
            src: null,
          },
          field2: {
            label: '請選擇圖片 2',
            value: null,
            errorMsg: '',
            rules: [(v) => !!v || '此欄位必填'],
            hint: '請上傳用大小在 5 MB 以內的 PNG、GIF (不接受動畫)或 JPG 檔案',
            src: null,
          },
          field3: {
            label: '大標題（最多 12 個字）',
            placeholder: '',
            value: '',
            rules: [(v) => !!v || '此欄位必填'],
            errorMsg: '',
            maxlength: '12',
          },
          field4: {
            label: '說明文字（選填，最多 16 個字）',
            placeholder: '',
            value: '',
            rules: [(v) => !!v || '此欄位必填'],
            errorMsg: '',
            maxlength: '16',
          },
        },
        child3: {
          title: '意願調查',
          selected: [],
          items: [],

          field4: {
            label: '小芋頭廣告服務【免責聲明】',
            contant: `當您使用小芋頭廣告免費製作服務後，您已詳細閱讀及明確瞭解本「免責聲明」並同意，屬下列情況發生時本網站毋須負擔任何責任：
一、您提供之廣告文案、素材如有侵害他人著作權之風險會由您個人承擔。用戶同意使用「小芋頭廣告免費製作服務」系基於用戶的個人意願，並同意自負任何風險。

二、「小芋頭廣告免費製作服務」，不負任何明示或默示之擔保責任。「小芋頭廣告免費製作服務」不保證各項服務之穩定、安全、無誤、及不中斷；用戶明示承擔使用本服務之所有風險及可能發生之任何損害。

三、用戶在「小芋頭社群廣告申請」填寫之物件資訊、個人資料、上傳圖片等行為，純屬用戶個人行為，「小芋頭社群」對其內容之真實性或完整性不負有任何責任。

四、任何由於電腦病毒侵入或發作、因政府管制而造成的暫時性關閉等影響網路正常經營之不可抗力而造成的資料損毀、丟失、被盜用或被竄改等與「小芋頭社群」無關。

五、對於用戶透過「小芋頭社群」刊登或發布虛假、違法資訊、侵害他人權益及詐騙、敲詐行為者，純屬用戶個人行為「小芋頭社群」對因此而產生的一次糾紛不負任何責任！特此聲明。`,
            value: true,
            rules: [],
            errorMsg: '',
          },
        },
      },
      applyBtn: {
        name: '送出申請',
        disabled: false,
        loading: false,
      },
      blockSuccess: {
        img: require('@/assets/image/ads/Success.svg'),
        text1: '申請成功',
        text2: '感謝您申請小芋頭廣告',
        text3: '我們需數個工作天審核您的廣告資料是否完整，若確認無誤，我們將會寄送廣告上架通知至您留下的電子郵件中，若您遲遲無收到通知，請於您的垃圾信件中尋找，或點擊',
        text4: '聯絡我們',
        btn: {
          name: '再申請一筆',
          disabled: false,
          loading: false,
        },
      },
      blockGoTo: {
        title: '繼續前往',
        data: [
          {
            id: 0,
            title: '免費建立會員網站',
            sub: '使用小芋頭社群建立免費會員網站並邀請好友加入',
            img: require('@/assets/image/ads/ads-keepgoing-img01.jpg'),
            url: process.env.VUE_APP_MAIN_SMS_BASE_URL,
          },
          {
            id: 1,
            title: '探索感興趣的社群',
            sub: '盡情探索及搜尋您感興趣的社群',
            img: require('@/assets/image/ads/ads-keepgoing-img02.jpg'),
            url: process.env.VUE_APP_MAIN_SMS_BASE_URL + '/moreCommunities',
          },
          {
            id: 2,
            title: '前往我的社群',
            sub: '前往您已建立或加入的社群',
            img: require('@/assets/image/ads/ads-keepgoing-img03.jpg'),
            url: process.env.VUE_APP_MAIN_SMS_BASE_URL + '/ownCommunity',
          },
        ],
      },
      addressDialog: {
        show: false,
        title: '公司單位地址 ',
        confirm: '確定',
        close: '關閉',
        field1: {
          label: '國家',
          placeholder: '',
          items: [],
          value: '',
          tempValue: '',
          rules: [],
          errorMsg: '',
        },
        field2: {
          label: '城市',
          placeholder: '',
          items: [],
          value: '',
          tempValue: '',
          rules: [],
          errorMsg: '',
        },
        field3: {
          label: '區',
          placeholder: '',
          items: [],
          value: '',
          tempValue: '',
          rules: [],
          errorMsg: '',
        },
        field4: {
          label: '郵遞區號',
          placeholder: '',
          value: '',
          tempValue: '',
          rules: [],
          errorMsg: '',
        },
        field5: {
          label: '街道地址',
          placeholder: '',
          value: '',
          tempValue: '',
          rules: [],
          errorMsg: '',
        },
      },
      industryDialog: {
        show: false,
        clear: false,
        selectedList: [],
        selectedFormatList: [],
      },
      categoryDialog: {
        show: false,
        selectedList: [],
        selectedFormatList: [],
      },
      areaDialog: {
        show: false,
        clear: false,
        selectedList: [],
        selectedFormatList: [],
      },
      companyDatas: [],
      allIndustryDatas: [],
      allAreaDatas: [],
    };
  },
  mounted() {
    // if (this.$route.query.free === "1") this.service = true;
    // else this.service = false;
    this.applySuccess = false;

    this.SetDefauleAddress();

    let today = new Date();
    this.block4.field2.date = this.block4.field2.value = this.DateFormat(today);
    this.block4.field3.date = this.block4.field3.value = this.DateFormat(today.setFullYear(today.getFullYear() + 1));

    this.Advertise_Get_TaroSerivceApi();
    this.Advertise_Get_QuestionnaireApi();
    this.IndustryCategory_Get_API();
    this.Advertise_Get_AreaApi();
    this.Advertise_Get_DistApi();
  },
  watch: {
    'block4.field2.menu'(val) {
      val && setTimeout(() => (this.block4.field2.activePicker = 'YEAR'));
    },
    'block4.field3.menu'(val) {
      val && setTimeout(() => (this.block4.field3.activePicker = 'YEAR'));
    },
    'addressDialog.field2.value'() {
      // 依城市改行政區
      this.addressDialog.field3.items = dic[this.addressDialog.field2.value];
      if (!this.addressDialog.field3.tempValue) {
        this.addressDialog.field3.value = this.addressDialog.field3.items[0];
      }
    },
    'addressDialog.field3.value'() {
      // 依行政區改郵遞區號
      Cities.find((x) => {
        if (x.name === this.addressDialog.field2.value) {
          x.areas.find((y) => {
            if (y.name === this.addressDialog.field3.value) this.addressDialog.field4.value = y.zip;
          });
        }
      });
    },
    'block5.child3.selected'(val) {
      // 意願調查跟暫不考慮擇一 陣列處理
      if (val.length < 1) return;
      let noId = this.block5.child3.items[this.block5.child3.items.length - 1].id;
      let lastId = val[val.length - 1];
      if (val.length > 1) {
        if (lastId === noId) {
          this.block5.child3.selected = [];
          this.block5.child3.selected.push(noId);
        } else {
          let index = this.block5.child3.selected.indexOf(noId);
          if (index > -1) this.block5.child3.selected.splice(index, 1);
        }
      }
    },
    'block5ver2.child3.selected'(val) {
      // 意願調查跟暫不考慮擇一 陣列處理
      if (val.length < 1) return;
      let noId = this.block5ver2.child3.items[this.block5ver2.child3.items.length - 1].id;
      let lastId = val[val.length - 1];
      if (val.length > 1) {
        if (lastId === noId) {
          this.block5ver2.child3.selected = [];
          this.block5ver2.child3.selected.push(noId);
        } else {
          let index = this.block5ver2.child3.selected.indexOf(noId);
          if (index > -1) this.block5ver2.child3.selected.splice(index, 1);
        }
      }
    },
    'block3.field1.search'(val) {
      // 選項冷卻時間 (才不會又搜一次)
      if (this.block3.field1.searchResult) return;
      if (!val) {
        this.companyDatas = [];
        this.noCompanyData = true;
        return;
      }
      // 排除注音
      var pattern = /[\u3105-\u3129\u02CA\u02C7\u02CB\u02D9]/;
      if (pattern.test(val)) return;

      this.GetCompanyData_API(val);
    },
    'block3.field1.value'(val) {
      if (!val) return;
      // 塞地址
      // 選項冷卻時間 (才不會又搜一次)
      this.block3.field1.searchResult = true;
      this.block3.field1.search = val.公司名稱;

      this.block3.field2.value = val.公司地址;
      this.addressDialog.field2.tempValue = val.公司地址.substring(0, 3);
      this.addressDialog.field3.tempValue = val.公司地址.substring(3, 6);
      this.addressDialog.field5.tempValue = val.公司地址.substring(6);

      // 拿統編去財政部API查行業別
      if (val.公司統編) {
        GetIndustryVAT(val.公司統編)
          .then((res) => {
            let industry = [];
            if (res.data.industryNm) industry.push(res.data.industryNm);
            if (res.data.industryNm1) industry.push(res.data.industryNm1);
            if (res.data.industryNm2) industry.push(res.data.industryNm2);
            if (res.data.industryNm3) industry.push(res.data.industryNm3);
            this.block3.field3.items = industry;
            this.block3.field3.value = industry;
          })
          .catch((err) => {
            console.log(err);
          });
      }

      // 塞地區
      let address = [];
      address.push(val.公司地址.substring(0, 3));
      address.push(val.公司地址.substring(3, 6));
      this.areaDialog.selectedList = this.AreaNameToId(address[0], address[1]);
      this.block4.field5.items = address;
      this.block4.field5.value = address;
    },
    'block5ver2.child2.field1.value'(val) {
      if (val === null) {
        this.block5ver2.child2.field1.src = null;
      }
    },
    'block5ver2.child2.field2.value'(val) {
      if (val === null) {
        this.block5ver2.child2.field2.src = null;
      }
    },
    companyDatas(val) {
      if (val.length > 0) {
        this.companyMenu = true;
      }
    },
    deep: true,
  },

  methods: {
    //#region 設定公司單位地址初始值
    SetDefauleAddress() {
      this.addressDialog.field1.items.push('台灣');
      this.addressDialog.field1.value = '台灣';

      this.addressDialog.field2.items = towns;
      this.addressDialog.field2.value = towns[0];
    },
    //#endregion
    //#region  *** 地址彈窗 functions
    // 打開彈窗
    AddressDialogOpen() {
      this.addressDialog.show = true;
      this.SetDefauleAddress();

      if (this.addressDialog.field3.tempValue) {
        this.addressDialog.field1.value = this.addressDialog.field1.tempValue;
        this.addressDialog.field2.value = this.addressDialog.field2.tempValue;
        this.addressDialog.field3.value = this.addressDialog.field3.tempValue;
        this.addressDialog.field4.value = this.addressDialog.field4.tempValue;
        this.addressDialog.field5.value = this.addressDialog.field5.tempValue;
      }
    },
    // 確認輸入地址
    AddressDialogConfirm() {
      this.block3.field2.value =
        `${this.addressDialog.field4.value} ` +
        // `${this.addressDialog.field1.value} ` +
        `${this.addressDialog.field2.value} ` +
        `${this.addressDialog.field3.value} ` +
        `${this.addressDialog.field5.value}`;
      this.addressDialog.show = false;

      // 暫存地址
      this.addressDialog.field1.tempValue = this.addressDialog.field1.value;
      this.addressDialog.field2.tempValue = this.addressDialog.field2.value;
      this.addressDialog.field3.tempValue = this.addressDialog.field3.value;
      this.addressDialog.field4.tempValue = this.addressDialog.field4.value;
      this.addressDialog.field5.tempValue = this.addressDialog.field5.value;
    },
    //#endregion
    //#region  *** 公司行業別彈窗 functions
    // 開啟彈窗
    IndustryDialogOpen() {
      this.industryDialog.show = true;

      if (this.block3.field3.items) {
        this.industryDialog.selectedList = this.IndustryTextToId(this.block3.field3.items);
      }
    },
    // 關閉彈窗
    IndustryDialogClose(data) {
      if (data) this.industryDialog.show = false;
    },
    // 已選行業別List
    IndustryResultList(data) {
      this.industryDialog.selectedList = data;
      this.industryDialog.show = false;
    },
    // 已選行業別FormatList
    IndustryResultFormatList(data) {
      this.industryDialog.selectedFormatList = data;
      this.block3.field3.items = data;
      this.block3.field3.value = data;
    },
    //#endregion
    //#region  *** 類型彈窗 functions
    // 開啟彈窗
    CategoryDialogOpen() {
      this.categoryDialog.show = true;
    },
    // 關閉彈窗
    CategoryDialogClose(data) {
      if (data) this.categoryDialog.show = false;
    },
    // 已選類型型List
    CategoryResultList(data) {
      this.categoryDialog.selectedList = data;
      this.categoryDialog.show = false;
    },
    // 已選類型FormatList
    CategoryResultFormatList(data) {
      this.categoryDialog.selectedFormatList = data;
      this.block4.field4.items = data;
      this.block4.field4.value = data;
    },
    //#endregion
    //#region  *** 地區彈窗 functions
    // 開啟彈窗
    AreaDialogOpen() {
      this.areaDialog.show = true;
    },
    // 關閉彈窗
    AreaDialogClose(data) {
      if (data) this.areaDialog.show = false;
    },
    // 已選類型型List
    AreaResultList(data) {
      this.areaDialog.selectedList = data;
      this.areaDialog.show = false;
    },
    // 已選類型FormatList
    AreaResultFormatList(data) {
      this.areaDialog.selectedFormatList = data;

      this.block4.field5.items = data;
      this.block4.field5.value = data;
    },
    //#endregion
    //#region 日期選擇器
    // 日期選擇器1 儲存
    b4f2menuSave(date) {
      this.block4.field2.value = date;
      this.block4.field2.menu = false;
    },
    // 日期選擇器2 儲存
    b4f3menuSave(date) {
      this.block4.field3.value = date;
      this.block4.field3.menu = false;
    },
    // 日期format
    DateFormat(date) {
      let d = new Date(date);
      let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      return `${ye}-${mo}-${da}`;
    },
    //#endregion

    //#region 照片上傳
    async ImgUploadEvent(e, imgSize) {
      let wh = null;
      switch (imgSize) {
        case 'lg':
          if (e === null) {
            this.block5.child2.lg.errorMsg = '';
            return;
          }
          if (e.size > 5 * 1000 * 1000) {
            this.block5.child2.lg.errorMsg = '超過限制大小，請重新選擇上傳。';
            return;
          }
          wh = await this.GetWidthAndHeight(e);
          if (wh.width !== 1280 && wh.height !== 90) {
            this.block5.child2.lg.errorMsg = '圖片尺寸不符，請重新上傳：寬1280x高90像素圖片。';
            return;
          }
          this.block5.child2.lg.errorMsg = '';
          break;
        case 'md':
          if (e === null) {
            this.block5.child2.md.errorMsg = '';
            return;
          }
          if (e.size > 5 * 1000 * 1000) {
            this.block5.child2.md.errorMsg = '超過限制大小，請重新選擇上傳。';
            return;
          }
          wh = await this.GetWidthAndHeight(e);
          if (wh.width !== 1440 && wh.height !== 180) {
            this.block5.child2.md.errorMsg = '圖片尺寸不符，請重新上傳：寬1440x高180像素圖片。';
            return;
          }
          this.block5.child2.md.errorMsg = '';
          break;
        case 'sm':
          if (e === null) {
            this.block5.child2.sm.errorMsg = '';
            return;
          }
          if (e.size > 5 * 1000 * 1000) {
            this.block5.child2.sm.errorMsg = '超過限制大小，請重新選擇上傳。';
            return;
          }
          wh = await this.GetWidthAndHeight(e);
          if (wh.width !== 686 && wh.height !== 146) {
            this.block5.child2.sm.errorMsg = '圖片尺寸不符，請重新上傳：寬686x高164像素圖片。';
            return;
          }
          this.block5.child2.sm.errorMsg = '';
          break;
        case 'c1':
          if (e === null) {
            this.block5ver2.child2.field1.errorMsg = '';
            return;
          }
          if (e.size > 5 * 1000 * 1000) {
            this.block5ver2.child2.field1.errorMsg = '超過限制大小，請重新選擇上傳。';
            return;
          }
          this.block5ver2.child2.field1.errorMsg = '';
          break;
        case 'c2':
          if (e === null) {
            this.block5ver2.child2.field2.errorMsg = '';
            return;
          }
          if (e.size > 5 * 1000 * 1000) {
            this.block5ver2.child2.field2.errorMsg = '超過限制大小，請重新選擇上傳。';
            return;
          }
          this.block5ver2.child2.field2.errorMsg = '';
          break;
        default:
          console.log(imgSize);
      }
      this.CovertToWebp(e, imgSize);
    },
    // 轉webp檔
    CovertToWebp(files, imgSize) {
      const image = new Image();
      const reader = new FileReader();
      reader.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        canvas.getContext('2d').drawImage(image, 0, 0);
        canvas.toBlob(
          (blob) => {
            const myImage = new File([blob], `${this.removeExtension(files.name)}.webp`);
            console.log(myImage);
          },
          'image/webp',
          0.7
        );
      };
      reader.readAsArrayBuffer(files);

      this.previewImage(files, imgSize);
    },
    // 預覽圖片
    previewImage(files, imgSize) {
      let src = URL.createObjectURL(files);
      if (imgSize === 'c1') {
        this.block5ver2.child2.field1.src = src;
      } else if (imgSize === 'c2') {
        this.block5ver2.child2.field2.src = src;
      }
    },
    // 去附檔名
    removeExtension(fileName) {
      let extIndex = fileName.lastIndexOf('.');
      if (extIndex != -1) {
        return fileName.substr(0, extIndex);
      }
    },
    // 取得長寬
    GetWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        console.log(window.URL);
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        image.onload = () =>
          resolve({
            width: image.width,
            height: image.height,
          });
        image.onerror = reject;
        image.src = _URL.createObjectURL(file);
      });
    },
    //#endregion

    //#region 重設部分表單
    ResetForm() {
      this.block3.field3.vlaue = [];
      this.block4.field4.value = [];
      this.block4.field5.value = [];
      this.block4.field6.value = '';
      this.block5.child2.lg.value = null;
      this.block5.child2.md.value = null;
      this.block5.child2.sm.value = null;
      this.block5.child3.selected = [];
      this.block5ver2.child2.field1.value = null;
      this.block5ver2.child2.field2.value = null;
      this.block5ver2.child2.field3.value = '';
      this.block5ver2.child2.field4.value = '';
      this.block5ver2.child3.selected = [];
    },
    //#endregion
    //#region 另開連結
    LinkingTo(url) {
      let newWindow = window.open();
      newWindow.location.href = url;
    },
    //#endregion
    //#region 控制滾動到底部才顯示 (暫時不用)
    HandleScroll(e) {
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight >= e.srcElement.scrollHeight) {
        if (this.service) this.block5ver2.child3.field4.readonly = false;
        else this.block5.child3.field4.readonly = false;
      }
    },
    //#endregion

    //#region 塞資料
    SetPostData() {
      let formData = new FormData();
      formData.append('ApplyName', this.block2.field1.value);
      formData.append('ApplyEmail', this.block2.field2.value);
      formData.append('ApplyPhone', this.block2.field3.value);
      formData.append('ApplyCompany', this.block3.field1.search);
      formData.append('ApplyAddress', this.block3.field2.value);
      this.industryDialog.selectedList.forEach((v, i) => {
        formData.append(`CompanyIndustries[${i}]`, v);
      });
      formData.append('Introducer', this.block3.field4.value);
      formData.append('Consultant', this.block3.field6.value);
      formData.append('KfCustomer', this.block3.field5.value);
      this.block4.field1.selected.forEach((v, i) => {
        formData.append(`Services[${i}]`, v.id);
      });
      formData.append('StartDate', this.block4.field2.value);
      formData.append('EndDate', this.block4.field3.value);
      this.categoryDialog.selectedList.forEach((v, i) => {
        formData.append(`Categories[${i}]`, v);
      });
      // 2022.12.26 修改
      //   this.areaDialog.selectedList.forEach((v, i) => {
      //     formData.append(`Areas[${i}]`, v);
      //   });
      // 2024.06.12 修改
      this.areaDialog.selectedList.forEach((v, i) => {
        formData.append(`Districts[${i}]`, v);
      });
      formData.append('AdvertiseUrl', this.block4.field6.value);
      formData.append('AdvertiseBudget', this.block4.field7.value);
      formData.append('Image.Lg', this.block5.child2.lg.value);
      formData.append('Image.Md', this.block5.child2.md.value);
      formData.append('Image.Sm', this.block5.child2.sm.value);
      formData.append('Image.Custom1', this.block5ver2.child2.field1.value);
      formData.append('Image.Custom2', this.block5ver2.child2.field2.value);
      formData.append('Image.Title', this.block5ver2.child2.field3.value);
      formData.append('Image.Content', this.block5ver2.child2.field4.value);
      if (this.block5.child3.selected.length > 0) {
        this.block5.child3.selected.forEach((v, i) => {
          formData.append(`Questionnaires[${i}]`, v);
        });
      }
      if (this.block5ver2.child3.selected.length > 0) {
        this.block5ver2.child3.selected.forEach((v, i) => {
          formData.append(`Questionnaires[${i}]`, v);
        });
      }

      return formData;
    },
    //#endregion
    //#region 送出申請
    Apply() {
      let flag = false;
      this.$refs.form.validate();
      if (!this.$refs.form.validate()) flag = true;
      if (!this.block5.child3.field4.value || !this.block5ver2.child3.field4.value) {
        flag = true;
        this.block5.child3.field4.errorMsg = this.block5ver2.child3.field4.errorMsg = '請勾選免責聲明';
      } else {
        this.block5.child3.field4.errorMsg = this.block5ver2.child3.field4.errorMsg = '';
      }

      if (flag) {
        this.validAlert = true;
        setTimeout(() => {
          this.validAlert = false;
        }, 5000);
        return;
      }
      this.applyBtn.loading = true;
      let data = this.SetPostData();
      this.Advertise_PostApi(data);
    },
    //#endregion

    //#region Advertise_Post API
    Advertise_PostApi(data) {
      Advertise_Post(data)
        .then((res) => {
          console.log(res);
          this.applySuccess = true; // 申請成功
          this.$vuetify.goTo(0);
          this.ResetForm(); // 重設表單

          //寄信
          let model = {
            id: res.data.data.id,
            industrys: this.industryDialog.selectedFormatList,
          };
          this.Advertise_SemdAdminMailApi(model);
        })
        .catch((err) => {
          console.log(err.data.response.message);
          this.validAlert = true;
          this.alertText = err.response.data.message;
          setTimeout(() => {
            this.validAlert = false;
          }, 5000);
        })
        .finally(() => {
          this.applyBtn.loading = false;
        });
    },
    //#endregion

    //#region Advertise_Get_TaroSerivce API
    Advertise_Get_TaroSerivceApi() {
      Advertise_Get_TaroSerivce()
        .then((res) => {
          let result = res.data.data;
          this.block4.field1.items = result;
          this.block4.field1.selected.push(result[0]);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //#endregion

    //#region Advertise_Get_Questionnaire API
    Advertise_Get_QuestionnaireApi() {
      Advertise_Get_Questionnaire()
        .then((res) => {
          let result = res.data.data;
          let item1 = result.splice(0, 1);
          this.block5.child3.items = result.concat(item1);
          this.block5ver2.child3.items = result.concat(item1);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //#endregion

    //#region Get 行政區 API
    Advertise_Get_DistApi() {
      Advertise_Get_Dist()
        .then((res) => {
          this.block4.field5.distDatas = res.data.data;
        })
        .catch((err) => {
          console.log(err);
          this.block4.field5.distDatas = [];
        });
    },
    //#endregion

    // #region 申請成功後寄信給行政 API
    Advertise_SemdAdminMailApi(data) {
      Advertise_SemdAdminMail(data)
        .then((res) => {
          console.log(res.data.data.message);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    // #endregion

    // #region Get 公司資料
    GetCompanyData_API(name) {
      this.block3.field1.loading = true;
      this.noCompanyData = false;
      GetCompanyData(name, 20)
        .then((res) => {
          this.companyDatas = res.data.data;
          if (res.data.data.length < 1) {
            // this.companyDatas.push(name);
            this.companyDatas = [];
            this.noCompanyData = true;
          } else {
            this.noCompanyData = false;
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.companyDatas = [];
          //   this.companyDatas.push(name);
          this.noCompanyData = true;
        })
        .finally(() => {
          //   setTimeout(() => {
          this.block3.field1.loading = false;
          //   }, 1500);
        });

      //   let data = {
      //     cityName: "",
      //     name: "",
      //     lawNumber: 0,
      //     punishStartYearMonth: null,
      //     punishEndYearMonth: null,
      //     businessItem: "",
      //     isVaildRepresentative: false,
      //     companyName: keyword,
      //     companyStatus: "核准設立",
      //     businessItems: [],
      //     topCount: "20",
      //     isIgnoreHasExportToLetter: true,
      //     page: 1,
      //     pageSize: 500,
      //     illegalType: null,
      //   };
      //   GetCompanyData_Post(data)
      //     .then((res) => {
      //       this.companyDatas = res.data.data;
      //     })
      //     .catch((err) => {
      //       console.log(err.response.data.status);
      //       this.companyDatas = [];
      //     })
      //     .finally(() => {
      //       this.block3.field1.loading = false;
      //     });
    },
    // #endregion

    //#region 撈 公司行業類別 API
    IndustryCategory_Get_API() {
      IndustryCategory_Get()
        .then((res) => {
          this.allIndustryDatas = this.IndustryCategoryFormat(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.allIndustryDatas = this.IndustryCategoryFormat(industryJson);
          //   this.allIndustryDatas = [];
        });
    },
    //#endregion

    //#region 重組行業別資料
    IndustryCategoryFormat(datas) {
      let formatedList = [];
      datas.forEach((x) => {
        let newFormat = {
          id: x.id,
          text: x.text,
          layer: x.layer,
          children: null,
        };

        let lastChildren = [];
        this.IndustryCategoryRecursive(x.children, lastChildren);
        newFormat.children = lastChildren;
        formatedList.push(newFormat);
      });
      return formatedList;
    },
    //#endregion

    //#region 遞迴撈資料
    IndustryCategoryRecursive(list, lastChildren) {
      list.forEach((x) => {
        if (x.children === null) {
          lastChildren.push(x);
          return;
        }
        this.IndustryCategoryRecursive(x.children, lastChildren);
      });
    },
    //#endregion

    //#region  行業別名稱轉成編號
    IndustryTextToId(list) {
      let list2 = [];
      list.forEach((x) => {
        this.allIndustryDatas.forEach((y) => {
          y.children.forEach((z) => {
            if (z.text === x) list2.push(z.id);
          });
        });
      });
      return list2;
    },
    //#endregion

    //#region Get廣告地區 API
    Advertise_Get_AreaApi() {
      Advertise_Get_Area()
        .then((res) => {
          this.allAreaDatas = res.data.data;
        })
        .catch((err) => {
          console.log(err);
          this.allAreaDatas = [];
        });
    },
    //#endregion

    //#region 地區名稱轉成編號
    AreaNameToId(area, dist) {
      let format = [];
      this.block4.field5.distDatas.forEach((x) => {
        if (x.name === area) {
          x.dists.forEach((y) => {
            if (y.name === dist) {
              format.push(y.id);
            }
          });
        }
      });
      return format;
    },
    //#endregion

    // 再申請一筆
    ApplyAgain() {
      this.applySuccess = false;
    },
    // 滾動到指定idf
    ScrollTo(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    },
    SeletctCompany(x) {
      this.block3.field1.value = x;
      // 選項冷卻時間 (才不會又搜一次)
      setTimeout(() => {
        this.block3.field1.searchResult = false;
      }, 500);
    },
  },
  computed: {
    BodyHeight() {
      return window.innerHeight;
    },
  },
};
</script>

<style scoped>
.input-width {
  width: 70%;
}
@media only screen and (max-device-width: 500px) {
  .input-width {
    width: 100%;
  }
}

.image-container {
  position: relative;
  display: inline-block;
  border: 2px solid var(--green-green, #4caf50);
  padding: 8px;
  border-radius: 8px;
}

.image-container img {
  display: block;
}

.delete-button {
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: #ffffff;
}

.pre-img {
  max-width: 104px;
  max-height: 104px;
  object-fit: contain;
}
</style>
